import script from "./BusinessNotification.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessNotification.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessNotification.vue?vue&type=style&index=0&id=68e3b017&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e3b017"]])

export default __exports__